import React, { useEffect } from "react";
import { HeroReuse } from "../../components/common/HeroReuse";
import FeatureDisplay from "../../components/common/FeatureDisplay";
import RequestDemo from "../../components/common/RequestDemo";
import { consultantAndAdvisorsInfo, consultantsAndAdvisorsFeatures, licenseManagementFeatures } from "./solutionConstants";
import ProblemSolved from "../../components/sections/corporateManagement/ProblemSolved";
import consultantAndAdvisorsAnimation from '../../website animations/Consultants animation (3) 3.json'
import { useLocation } from "react-router-dom";

const ConsultantAndAdvisors = () => {
  const location = useLocation();

  useEffect(() => {
    console.log('solution');
    const sectionId = location.hash.substring(1);
    const section = document.getElementById(sectionId);
    if(section){      
      window.scrollTo({
        top: section.offsetTop - 100,
        behavior: "smooth"
      });
    }
  }, [location]);

  return (
    <div id="solution" className="flex flex-col items-center justify-center gap-8 sm:gap-16">
      <HeroReuse
        Subtitle="SOLUTIONS"
        Title="Consultants & Advisors Solutions"
        Description="Your automation partner."
        // ButtonText="Request a Demo Today"
        lottie={consultantAndAdvisorsAnimation}
      />
      <FeatureDisplay infoSectionData={consultantAndAdvisorsInfo} data={consultantsAndAdvisorsFeatures} />
      <ProblemSolved features={licenseManagementFeatures}/>
      <RequestDemo 
       title={'Learn More About Consultant Solutions'} />
    </div>
  );
};

export default ConsultantAndAdvisors;
